import React, { useEffect, useState } from 'react';
import ClientRetentionScore from "../../components/ClientRetentionScore/ClientRetentionScore";
import ClientOnboardingStatus from "../../components/ClientOnboardingStatus/ClientOnboardingStatus";
import RevenueGrowth from "../../components/RevenueGrowth/RevenueGrowth";
import MonthlyRevenue from "../../components/MonthlyRecurringRevenue/MonthlyRecurringRevenue";
import ChurnPercentage from "../../components/ChurnPercentage/ChurnPercentage";
import ChurnForecast from "../../components/ChurnForecast/ChurnForecast";
import ClientEngagementTrends from "../../components/ClientEngagementTrends/ClientEngagementTrends";
import DateLastContacted from '../../components/DateLastContacted/DateLastContacted';
import IcpSegmentation from '../../components/IcpSegmentation/IcpSegmentation';
import ClientBillingStatus from '../../components/ClientBillingStatus/ClientBillingStatus';
import ClientProgram from '../../components/ClientProgram/ClientProgram';
import DashboardCSMSelector from '../../components/DashboardCSMSelector/DashboardCSMSelector';
import axios from 'axios';
import { API_URL } from "../../utils/auth";
import Auth from '../../utils/auth';
import './Dashboard.css';  

const Dashboard = () => {

    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCSMId, setSelectedCSMId] = useState(() => {
        const saved = localStorage.getItem('selectedCSMId');
        return saved ? saved : null;
    });

    const workspaceId = Auth.getWorkspaceId();
    const user = Auth.getUser();
    const isAdmin = user?.admin || false;

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                const params = { workspaceId };

                if (isAdmin && selectedCSMId === 'all-csms') {
                    params.onlyCsmClients = true;
                } else if (isAdmin && selectedCSMId !== null && selectedCSMId !== undefined) {
                    params.userId = selectedCSMId;
                } else if (isAdmin && selectedCSMId === null) {
                }
                
                const response = await axios.get(`${API_URL}/utils/getdashboard`, {
                    params
                });
                setDashboardData(response.data);
            } catch (err) {
                setError('Error fetching dashboard data');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        if (workspaceId) fetchDashboard();
    }, [workspaceId, selectedCSMId, isAdmin]);

    const handleCSMChange = (csmId) => {
        if (csmId !== selectedCSMId) {
            setSelectedCSMId(csmId);
            if (csmId) {
                localStorage.setItem('selectedCSMId', csmId);
            } else {
                localStorage.removeItem('selectedCSMId');
            }
            setLoading(true);
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="dashboard-container">
            <div className="top-row">
                <ClientRetentionScore score={Number(dashboardData.avgretentionscore) || 0} />
                <ClientOnboardingStatus data={dashboardData.onboarding} totalClients={dashboardData.totalclients} selectedUserId={isAdmin ? selectedCSMId : null} />
                <DateLastContacted totalclients={dashboardData.totalclients} lastContacted={dashboardData.lastContacted} />
                <IcpSegmentation totalclients={dashboardData.totalclients} icpDistribution={dashboardData.icpDistribution} selectedUserId={isAdmin ? selectedCSMId : null} />
            </div>

            <div className="center-row">
                {isAdmin ? (
                    <DashboardCSMSelector 
                        onCSMChange={handleCSMChange} 
                        selectedCSMId={selectedCSMId}
                        csmInfo={dashboardData?.csmInfo}
                        activeClients={dashboardData?.activeclients}
                        archivedClients={dashboardData?.archivedclients}
                    />
                ) : (
                    <div className="dashboard-spacer"></div>
                )}
                <ClientProgram programs={dashboardData.programs?.data} totalClients={dashboardData.programs?.total} selectedUserId={isAdmin ? selectedCSMId : null} />
                <ChurnForecast retentionScore={dashboardData.retentionScore} />
                <ClientBillingStatus totalclients={dashboardData.totalclients} billingStatus={dashboardData.billingStatus} selectedUserId={isAdmin ? selectedCSMId : null} />
            </div>
        </div>
    );
};

export default Dashboard;
